import React from 'react'
import { Box, Button } from '@mui/material'
import CalendarViewMonthIcon from '@mui/icons-material/CalendarViewMonth';
import TocIcon from '@mui/icons-material/Toc';

interface ActionsViewModeProps {
  readonly handleShowCalendar: (viewMode: 'calendar' | 'list') => void;
  readonly filters?: any[];
}

export default function ActionsViewMode({ handleShowCalendar, filters }: ActionsViewModeProps) {

  const handleView = (mode) => {
    const startDateFilter = filters?.find(filter => filter.name === 'start_date' || filter.type === 'start_date');
    const finishDateFilter = filters?.find(filter => filter.name === 'finish_date' || filter.type === 'finish_date');

    if (mode === 'list') {
      startDateFilter?.variable.set(null);
      finishDateFilter?.variable.set(null);
      handleShowCalendar('list')
    } else { 
      handleShowCalendar('calendar')
    }
  }
  
  return (
    <Box display={'flex'} alignItems='center' justifyContent='flex-end' gap={1} marginBottom={2} marginTop={2}>
      <Button
        color='primary'
        variant='contained'
        size='small'
        onClick={() => handleView('calendar')}>
        <CalendarViewMonthIcon />
      </Button>
      <Button
        color='primary'
        variant='contained'
        size='small'
        onClick={() => handleView('list')}
      >
        <TocIcon />
      </Button>
    </Box>
  )
}
